export default __webpack_public_path__ + "static/slider-1-10fe8ea2122f2055a956a42389b877f8.jpg";